<template>
  <Loader style="z-index:100000" v-if="loader" />

  <div v-if="!hideSearch" class="card">
    <div class="grid">
      <div class="col-12 lg:col-4">
          <h6 class="ml-2">Agente</h6>
          <MultiSelect @change="onSelectedChange('agents')"  v-model="list['selected.agents']" :options="list['agents']" optionLabel="name" optionValue="id"  placeholder="Seleziona agente" class="inputfield w-full mt-2" dataKey="id" filter @update:modelValue="changeSelection($event, 'agents')" optionDisabled="disabled"/>
          <div class="flex align-items-center mt-2" v-if="list['selected.agents'] && list['selected.agents'].length > 0">
            <Checkbox class="mr-2" v-model="useAgenteName" :binary="true" @change="onUseAgenteNameChange"/>
            <span>Utilizza Nome Agente</span>
          </div>
      </div>
      <div class="col-12 lg:col-4" v-if="!useAgenteName">
          <h6 class="ml-2">Rappresentante</h6>
          <MultiSelect
            @change="onSelectedChange('representatives')"
            v-model="list['selected.representatives']"
            :options="list['representatives']"
            optionLabel="name"
            optionValue="id"
            placeholder="Seleziona rappresentante"
            class="inputfield w-full mt-2"
            dataKey="id"
            filter
            :loading="loadingRepresentatives"
            @filter="onRepresentativeFilter"
          >
            <template #empty>
              <div class="text-center">
                {{ hasSearchedRepresentatives ? 'Nessuna opzione disponibile' : 'Inserisci il nome del rappresentante' }}
              </div>
            </template>
          </MultiSelect>
      </div>
      <div class="col-12 lg:col-4" v-if="useAgenteName && list['selected.agents'] && list['selected.agents'].length === 1">
          <h6 class="ml-2">Rappresentante Agente</h6>
          <Dropdown
            v-model="selectedRappresentanteFromAgente"
            :options="list['rappresentantiFromAgente']"
            optionLabel="name"
            optionValue="id"
            placeholder="Seleziona rappresentante"
            class="inputfield w-full mt-2"
            :loading="loadingRappresentantiFromAgente"
            :filter="false"
          >
            <template #empty>
              <div class="text-center">
                {{ loadingRappresentantiFromAgente ? 'Caricamento...' : 'Nessun rappresentante disponibile' }}
              </div>
            </template>
          </Dropdown>
      </div>
      <div class="col-12 lg:col-4">
          <h6 class="ml-2">Cliente</h6>
          <MultiSelect @change="onSelectedChange('clients')" v-model="list['selected.clients']" :options="list['clients']" optionLabel="name" optionValue="id"  placeholder="Seleziona cliente" class="inputfield w-full mt-2" dataKey="id" filter />
      </div>
      <div class="col-12 lg:col-4">
          <h6 class="ml-2">Agente Firmatario</h6>
          <MultiSelect @change="onSelectedChange('agente_firmatario')" v-model="list['selected.agente_firmatario']" :options="list['agente_firmatario']" optionLabel="name" optionValue="id" placeholder="Seleziona agente firmatario" class="inputfield w-full mt-2" dataKey="id" filter />
      </div>
      <div class="col-12 lg:col-4">
          <h6 class="ml-2">Anno/i Emissione</h6>
          <Calendar v-model="selectedYear" :showIcon="true" view="year" dateFormat="yy" selectionMode="multiple" class="inputfield w-full mt-2" @update:modelValue="changeSelection($event, 'year')"/>
      </div>
      <div class="col-12 lg:col-4">
          <h6 class="ml-2">Mese/Anno Emissione</h6>
          <Calendar v-model="selectedMonthYear" :showIcon="true" view="month" dateFormat="mm/yy" class="inputfield w-full mt-2" />
      </div>
      <div class="col-12 lg:col-6 flex align-items-center p-3">
          <div class="flex align-items-center">
            <Checkbox class="mr-2"  v-model="hasDetails" :binary="true"/>
            <span>Aggiungi dettagli fatture</span>
          </div>
          <div class="flex align-items-center ml-4">
            <Checkbox class="mr-2" v-model="rappresentanteFlag" :binary="true"/>
            <span>Mostra per rappresentante</span>
          </div>
      </div>
      <div class="col-12 lg:col-6 flex align-items-center justify-content-end p-3">
          <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" />
      </div>
    </div>
  </div>

  <div class="insoluti-summary">
    <div v-if="!hideSearch && items" class="flex justify-content-between flex-wrap mb-3">
      <div class="flex align-items-center justify-content-center mb-2">
        <MultiSelect v-model="selectedMonths" :showToggleAll="false" @change="setItems()" :options="mesi_filter" optionLabel="name" class="p-column-filter" style="min-width: 14rem" :maxSelectedLabels="2" placeholder="Seleziona mensilità"/>
      </div>
    </div>
    <div class="card" v-for="(el, label) in items" :key="label">
      <div class="flex align-items-center justify-content-end">
        <Button icon="pi pi-download" @click="exportPdfTable" class="p-button-secondary mr-2" label="Esporta Pdf" />
        <Button icon="pi pi-send" @click="sendMailReport" class="p-button-success" label="Invia Mail Riepilogo Al Credito" />
      </div>
      <div class="flex justify-content-between">
        <div><h4>{{label}}</h4></div>
        <div>
          <span
            v-if="(list['selected.agents'] || list['selected.agente_firmatario']) && hasDetails"
            @click="viewTotalRapps(label)"
            class="text-primary cursor-pointer"
          >
            Vedi totali rappresentanti
          </span>
        </div>
      </div>
      <DataTable :value="el" responsiveLayout="scroll">
          <!-- <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>
          </template> -->
          
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <ColumnGroup type="header">
            <Row>
              <Column header="" :colspan="1" style="min-width:160px;" />
              <Column class="th-power" header="POWER" :colspan="11" />
              <Column class="th-gas" header="GAS" :colspan="11" />
              <Column class="th-totali" header="TOTALI" :colspan="11" />
            </Row>
            <Row>
              <Column field="mese_emissione" :header="isGroupedByRappresentante ? 'Rappresentante' : 'Mese Emissione'"></Column>
              <Column field="totale_fatturato_energy" class="border-lt th-power">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Fatture
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_pagato_energy" class="border-lt th-power">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Pagato
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_insoluto_energy" class="border-lt th-power">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.insoluto
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_insoluto_active_energy" class="border-lt th-power" header="Tot.Insoluto Pdp Attivi" />
              <Column field="totale_insoluto_inactive_energy" class="border-lt th-power" header="Tot.Insoluto Pdp Inattivi" />
              <Column field="totale_insoluto_in_sospensione_energy" class="border-lt th-power" header="Tot.Insoluto Pdp in Sospensione" />
              <Column field="totale_insoluto_in_riattivazione_energy" class="border-lt th-power" header="Tot.Insoluto Pdp in Riattivazione" />
              <Column field="totale_insoluto_dilazioni_energy" class="border-lt th-power" header="Tot.Insoluto Pdp In Dilazione" />
              <Column class="border-lt th-power" header="% Insoluto" />
              <Column field="npdp_energy" class="border-lt th-power" header="N. punti" />
              <Column class="border-lt th-power" header="Dettagli" />
              <Column field="totale_fatturato_gas" class="border-lt th-gas">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Fatture
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_pagato_gas" class="border-lt th-gas">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Pagato
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_insoluto_gas" class="border-lt th-gas">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Insoluto
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="totale_insoluto_active_gas" class="border-lt th-gas" header="Tot.Insoluto Pdp Attivi" />
              <Column field="totale_insoluto_inactive_gas" class="border-lt th-gas" header="Tot.Insoluto Pdp Inattivi" />
              <Column field="totale_insoluto_in_sospensione_gas" class="border-lt th-gas" header="Tot.Insoluto Pdp in Sospensione" />
              <Column field="totale_insoluto_in_riattivazione_gas" class="border-lt th-gas" header="Tot.Insoluto Pdp in Riattivazione" />
              <Column field="totale_insoluto_dilazioni_gas" class="border-lt th-gas" header="Tot.Insoluto Pdp In Dilazione" />
              <Column class="border-lt th-gas" header="% Insoluto" />
              <Column field="npdp_gas" class="border-lt th-gas" header="N. punti" />
              <Column class="border-lt th-gas" header="Dettagli" />
              <Column field="" class="border-lt th-totali">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Fatture
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="" class="border-lt th-totali">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Pagato
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="" class="border-lt th-totali">
                <template #header>
                  <div class="flex flex-column">
                    <div  style="font-size: larger;">
                      Tot.Insoluto
                    </div>
                    <small class="p-small">Tot. Rid</small>
                  </div>
                </template>
              </Column>
              <Column field="" class="border-lt th-totali" header="Tot.Insoluto Pdp Attivi" />
              <Column field="" class="border-lt th-totali" header="Tot.Insoluto Pdp Inattivi" />
              <Column field="" class="border-lt th-totali" header="Tot.Insoluto Pdp in Sospensione" />
              <Column field="" class="border-lt th-totali" header="Tot.Insoluto Pdp in Riattivazione" />
              <Column field="" class="border-lt th-totali" header="Tot.Insoluto Pdp In Dilazione" />
              <Column class="border-lt" header="% Insoluto" />
              <Column field="" class="border-lt th-totali" header="N. punti" />
              <Column class="border-lt th-totali" header="Dettagli" />
            </Row>
          </ColumnGroup>

          <Column field="label_mese" class="sticky-cell"/>

          <Column field="totale_fatturato_energy" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_fatturato_energy)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_fatturato_energy)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_pagato_energy" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_pagato_energy)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_pagato_energy)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_insoluto_energy" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_insoluto_energy)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_insoluto_energy)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_insoluto_active_energy" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_active_energy)}}
            </template>
          </Column>
          <Column field="totale_insoluto_inactive_energy" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_inactive_energy)}}
            </template>
          </Column>
          <Column field="totale_insoluto_in_sospensione_energy" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_in_sospensione_energy)}}
            </template>
          </Column>
          <Column field="totale_insoluto_in_riattivazione_energy" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_in_riattivazione_energy)}}
            </template>
          </Column>
          <Column field="totale_insoluto_dilazioni_energy" class="border-lt">
            <template #body="{data}">
              {{ formatCurrency(data.totale_insoluto_dilazioni_energy) }}
            </template>
          </Column>
          <Column class="border-lt">
            <template #body="{data}">
              {{data.totale_fatturato_energy == 0 ? 0 : ((data.totale_insoluto_energy / data.totale_fatturato_energy) * 100).toFixed(2)}}%
            </template>
          </Column>
          <Column field="npdp_energy" class="border-lt">
            <template #body="{data}">
              {{data.npdp_energy}}
            </template>
          </Column>
           <Column header="Dettagli" class="border-lt">
            <template #body="{data, index}">
              <Button
                v-if="data.details_energy && Object.keys(data.details_energy).length > 0"
                label="Dettagli"
                class="p-button-text"
                @click="showDetailsInvoices(label, index, 'energy', label == 'TOTALE AGENZIE')"
              />
            </template>
          </Column>
        

         <Column field="totale_fatturato_gas" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_fatturato_gas)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_fatturato_gas)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_pagato_gas" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_pagato_gas)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_pagato_gas)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_insoluto_gas" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency(data.totale_insoluto_gas)}}
                </div>
                <small class="p-small">{{formatCurrency(data.totale_rid_insoluto_gas)}}</small>
              </div>
            </template>
          </Column>
          <Column field="totale_insoluto_active_gas" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_active_gas)}}
            </template>
          </Column>

          <Column field="totale_insoluto_inactive_gas" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_inactive_gas)}}
            </template>
          </Column>
          <Column field="totale_insoluto_in_sospensione_gas" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_in_sospensione_gas)}}
            </template>
          </Column>
          <Column field="totale_insoluto_in_riattivazione_gas" class="border-lt">
            <template #body="{data}">
              {{formatCurrency(data.totale_insoluto_in_riattivazione_gas)}}
            </template>
          </Column>
          <Column field="totale_insoluto_dilazioni_gas" class="border-lt">
            <template #body="{data}">
              {{ formatCurrency(data.totale_insoluto_dilazioni_gas) }}
            </template>
          </Column>
          <Column class="border-lt">
            <template #body="{data}">
              {{data.totale_fatturato_gas == 0 ? 0 : ((data.totale_insoluto_gas / data.totale_fatturato_gas) * 100).toFixed(2)}}%
            </template>
          </Column>
          <Column field="npdp_gas" class="border-lt">
            <template #body="{data}">
              {{data.npdp_gas}}
            </template>
          </Column>
           <Column header="Dettagli" class="border-lt">
            <template #body="{data, index}">
              <Button
                v-if="data.details_gas && Object.keys(data.details_gas).length > 0"
                label="Dettagli"
                class="p-button-text"
                @click="showDetailsInvoices(label, index, 'gas', label == 'TOTALE AGENZIE')"
              />
            </template>
          </Column>
         

           <Column field="" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency((data.totale_fatturato_energy + data.totale_fatturato_gas))}}
                </div>
                <small class="p-small">{{formatCurrency((data.totale_rid_fatturato_energy + data.totale_rid_fatturato_gas))}}</small>
              </div>
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency((data.totale_pagato_energy + data.totale_pagato_gas))}}
                </div>
                <small class="p-small">{{formatCurrency((data.totale_rid_pagato_energy + data.totale_rid_pagato_gas))}}</small>
              </div>
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              <div class="flex flex-column">
                <div  style="font-size: larger;">
                  {{formatCurrency((data.totale_insoluto_energy + data.totale_insoluto_gas))}}
                </div>
                <small class="p-small">{{formatCurrency((data.totale_rid_insoluto_energy + data.totale_rid_insoluto_gas))}}</small>
              </div>

            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{formatCurrency((data.totale_insoluto_active_energy + data.totale_insoluto_active_gas))}}
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{formatCurrency((data.totale_insoluto_inactive_energy + data.totale_insoluto_inactive_gas))}}
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{formatCurrency((data.totale_insoluto_in_sospensione_energy + data.totale_insoluto_in_sospensione_gas))}}
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{formatCurrency((data.totale_insoluto_in_riattivazione_energy + data.totale_insoluto_in_riattivazione_gas))}}
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{formatCurrency((data.totale_insoluto_dilazioni_energy + data.totale_insoluto_dilazioni_gas))}}
            </template>
          </Column>
          <Column class="border-lt">
            <template #body="{data}">
              <div v-if="data.totale_fatturato_energy == 0 || data.totale_fatturato_gas == 0">
                0%
              </div>
              <div v-else>
                {{(((data.totale_insoluto_energy + data.totale_insoluto_gas) / (data.totale_fatturato_energy + data.totale_fatturato_gas) * 100)).toFixed(2)}}%
              </div>
            </template>
          </Column>
          <Column field="" class="border-lt">
            <template #body="{data}">
              {{data.npdp_energy + data.npdp_gas}}
            </template>
          </Column>
           <Column header="Dettagli" class="border-lt">
            <!-- <template #body="{data, index}">
              <Button v-if="Object.keys(data.details_energy).length > 0 || Object.keys(data.details_gas).length > 0 " label="Dettagli"  class="p-button-text" @click="showDetailsInvoices(label, index)" />
            </template> -->
          </Column>
          
          
          <ColumnGroup type="footer">
            <Row>
                <Column :colspan="1" class="td-footer" footer="Totali"/>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_fatturato_energy')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_fatturato_energy')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_pagato_energy')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_pagato_energy')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_insoluto_energy')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_insoluto_energy')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_active_energy')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_inactive_energy')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_sospensione_energy')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_riattivazione_energy')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_dilazioni_energy')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotalPercent(items[label], 'energy')"/>
                <Column :colspan="2" class="td-footer" />

                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_fatturato_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_fatturato_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_pagato_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_pagato_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_insoluto_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_insoluto_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_active_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_inactive_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_sospensione_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_riattivazione_gas')"/>

                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_dilazioni_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotalPercent(items[label], 'gas')" />
                <Column :colspan="2" class="td-footer" />

                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_fatturato_energy', 'totale_fatturato_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_fatturato_energy', 'totale_rid_fatturato_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_pagato_energy', 'totale_pagato_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_pagato_energy', 'totale_rid_pagato_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer">
                  <template #footer>
                    <div class="flex flex-column">
                      {{calculateTotal(items[label], 'totale_insoluto_energy', 'totale_insoluto_gas')}}
                      <small>
                        {{calculateTotal(items[label], 'totale_rid_insoluto_energy', 'totale_rid_insoluto_gas')}}
                      </small>
                    </div>
                  </template>
                </Column>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_active_energy', 'totale_insoluto_active_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_inactive_energy', 'totale_insoluto_inactive_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_sospensione_energy', 'totale_insoluto_in_sospensione_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_in_riattivazione_energy', 'totale_insoluto_in_riattivazione_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotal(items[label], 'totale_insoluto_dilazioni_energy', 'totale_insoluto_dilazioni_gas')"/>
                <Column :colspan="1" class="td-footer" :footer="calculateTotalPercent(items[label], 'energy', 'gas')" />
                <Column :colspan="2" class="td-footer" />
            </Row>
          </ColumnGroup>
      </DataTable>
    </div>

  </div>
  <Dialog v-model:visible="detailsDialog" :style="{width: '85vw'}" header="Dettagli" :modal="true">
    <Loader style="z-index:100000" v-if="loader" />
    <div v-if="Object.keys(detailInvoices).length" class="card mb-3">
      <div class="formgrid grid mt-2">
        <div class="field col-6">
          <InputText @keyup="onGlobalSearch" class="mb-5 w-full" v-model="searchString" type="text" placeholder="Cerca per rappresentante..."/>
        </div>
        <div class="field col-3 flex justify-content-center">
          <Checkbox class="mt-2" id="removePaid" v-model="removePaid" :binary="true" @change="applyDetailFilters" />
          <label class="ml-2 mt-2" for="removePaid">Rimuovi saldati</label>
        </div>
        <div title="ordina" class="field col-3 text-right cursor-pointer text-primary pr-2">
          <i @click="onOrderDetails" class="pi pi-sort-alt" style="font-size: 1rem"></i>
        </div>
        <div class="field col-12 flex flex-wrap align-items-center">
          <div class="flex align-items-center mr-4 mb-2">
            <Checkbox id="removeDilazioni" v-model="removeDilazioni" :binary="true" @change="applyDetailFilters" />
            <label class="ml-2" for="removeDilazioni">Rimuovi in dilazione</label>
          </div>
          <div class="flex align-items-center mr-4 mb-2">
            <Checkbox id="removeCessati" v-model="removeCessati" :binary="true" @change="applyDetailFilters" />
            <label class="ml-2" for="removeCessati">Rimuovi PDP cessati</label>
          </div>
          <div class="flex align-items-center mr-4 mb-2">
            <Checkbox id="removeSospensione" v-model="removeSospensione" :binary="true" @change="applyDetailFilters" />
            <label class="ml-2" for="removeSospensione">Rimuovi in sospensione</label>
          </div>
          <div class="flex align-items-center mr-4 mb-2">
            <Checkbox id="removePreavvisi" v-model="removePreavvisi" :binary="true" @change="applyDetailFilters" />
            <label class="ml-2" for="removePreavvisi">Rimuovi preavvisi non scaduti</label>
          </div>
          <div class="flex align-items-center mr-4 mb-2">
            <Checkbox id="removeVolturati" v-model="removeVolturati" :binary="true" @change="applyDetailFilters" />
            <label class="ml-2" for="removeVolturati">Rimuovi POD/PDR volturati</label>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end">
        <Button icon="pi pi-download" label="Esporta Csv" @click="exportGlobalCsv()" class="p-button-secondary ml-2" />
        <Button icon="pi pi-download" label="Esporta Pdf" @click="exportPdf()" class="p-button-secondary ml-2" />
      </div>
    </div>
    <div class="card" v-for="(detailInvoicesAgent, agent) in detailInvoices" :key="agent">
      <h3>{{ agent }}</h3>
      <div class="insoluti-dialog">
        <Accordion :key="`${agent}-${detailFilterVersion}`" :multiple="true" lazy>
          <AccordionTab v-for="(details, keyName) in detailInvoicesAgent" :key="keyName">
            <template #header>
              <div class="flex justify-content-between flex-wrap w-full">
                <div class="flex align-items-center justify-content-left">
                  <div><small class="text-600">{{keyName}}</small> </div>
                </div>
                <i></i>
                <div class="text-left">
                  <div>
                    <small class="price">
                      <span class="text-500">Totale Fatture:</span>
                      {{formatCurrency(details.reduce((acc, el) => acc + el.totale_fattura, 0))}} - 
                      <small>
                        ( {{formatCurrency(details.filter((el)=> el.is_attiva == 0).reduce((acc, el) => acc + el.totale_fattura, 0))}} non attivi )
                      </small>
                    </small>
                  </div>
                  <div>
                    <small class="price">
                      <span class="text-500">Totale Pagato:</span>
                      {{formatCurrency(details.reduce((acc, el) => acc + el.pagato, 0))}} - 
                      <small> 
                        ( {{formatCurrency(details.filter((el)=> el.is_attiva == 0).reduce((acc, el) => acc + el.pagato, 0))}} non attivi )
                      </small>
                    </small>
                  </div>
                  <div>
                    <small class="price">
                      <span class="">Totale Insoluto:</span>
                      <span :class="details.reduce((acc, el) => acc + el.saldo, 0) > 0.1 ? 'p-error' : ''">
                        {{formatCurrency(details.reduce((acc, el) => acc + el.saldo, 0))}} - 
                        <small>
                          ( {{formatCurrency(details.filter((el)=> el.is_attiva == 0).reduce((acc, el) => acc + el.saldo, 0))}} non attivi )
                        </small>
                      </span>
                    </small>
                  </div>
                </div>
              </div>
            </template>
            <DataTable :value="details" responsiveLayout="scroll" dataKey="numero" :paginator="true" :rows="20" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10,20,50]"  currentPageReportTemplate="{first} a {last} di {totalRecords}">
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                  <div class="flex align-items-center justify-content-center">
                    <Button icon="pi pi-download" label="Esporta csv" @click="exportCSV(keyName)" class="p-button-secondary ml-2" />
                    <Button icon="pi pi-download" label="Esporta Pdf" @click="exportPdf(keyName)" class="p-button-secondary ml-2" />
                  </div>
                </div>
              </template>
              <template #empty>
                <div class="text-center">Nessun dato trovato.</div>
              </template>
              <Column field="numero" header="Numero" />
              <Column field="" header="Pdp">
                <template #body="{data}">
                  {{data.pod ?? data.pdr}}
                </template>
              </Column>
              <Column field="is_attiva" header="Attivo" :sortable="true">
                <template #body="{data}">
                  <div class="flex justify-content-center">
                    <div :class="{'green-dot': data.is_attiva, 'red-dot': !data.is_attiva}" v-tooltip="moment(data.data_fine).format('DD-MM-YYYY')"></div>
                  </div>
                </template>
              </Column>
              <Column field="stato_interno" header="Stato Interno" :sortable="true">
                <template #body="{data}">
                  {{ data.stato_interno ?? 'Non presente' }}
                </template>
              </Column>

              <Column field="ragsoc" header="Cliente" />
              <Column field="mese_fatturazione" header="Data competenza" :sortable="true">
                <template #body="{data}">
                  {{ moment(data.mese_fatturazione).isValid() ? moment(data.mese_fatturazione).format("DD-MM-YYYY") : '/' }}
                </template>
              </Column>
              <Column field="data_emissione" header="Data emissione" :sortable="true">
                <template #body="{data}">
                  {{ moment(data.data_emissione).isValid() ? moment(data.data_emissione).format("DD-MM-YYYY") : '/' }}
                </template>
              </Column>
              <Column field="data_scadenza" header="Data scadenza" :sortable="true">
                <template #body="{data}">
                  {{ moment(data.data_scadenza).isValid() ? moment(data.data_scadenza).format("DD-MM-YYYY") : '/' }}
                </template>
              </Column>
              <Column field="totale_fattura" header="Tot.Fattura" :sortable="true">
                <template #body="{data}">
                  {{formatCurrency(data.totale_fattura)}}
                </template>
              </Column>
              <Column field="pagato" header="Tot.Pagato" :sortable="true">
                <template #body="{data}">
                  {{formatCurrency(data.pagato)}}
                </template>
              </Column>
              <Column field="saldo" header="Saldo" :sortable="true">
                <template #body="{data}">
                  {{formatCurrency(data.saldo)}}
                </template>
              </Column>
              <Column field="rappresentante" header="Rappresentante" />
              <Column header="Azioni" style="min-width: 200px;">
                <template #body="{data}">
                  <div v-if="Number(data.saldo) > 0" class="flex justify-content-center">
                    <Button
                      v-if="data.is_preview_sospensione == 1 || previewSentInvoices.has(data.numero)"
                      label="Preview inviata"
                      icon="pi pi-check-circle"
                      class="p-button-sm p-button-success p-button-rounded"
                      disabled
                    />
                    <Button
                      v-else
                      label="Manda in preview"
                      icon="pi pi-send"
                      class="p-button-sm p-button-rounded preview-btn"
                      :loading="previewSendingInvoices.has(data.numero)"
                      @click="sendToPreview(data)"
                    />
                  </div>
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="hideDialog()"/>
    </template>
  </Dialog>
</template>

<script>
import moment from 'moment'
import Utility from '@/services/ask-management/utility-service'
import Service from '@/services/ask-pratiche/pratiche-service'
import ServiceOperation from '@/services/ask-operation/operation-service'
import { ref, onMounted, getCurrentInstance, watch, nextTick } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
    components: {
      Loader
    },
    props: {
      hideSearch: {
        type: Boolean,
        default: false
      },
      rappresentanteId: {
        type: [String, Number],
        default: null
      },
      anni: {
        type: Array,
        default: () => []
      }
    },
    setup() {
      // const dt = ref();
      const toast = useToast();
      const filters = ref({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const mesi_filter = ref([])
      const selectedMonths = ref()
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const serviceOperation = new ServiceOperation(self.$http, self.$eventBus)
      const utility = new Utility(self.$http, self.$eventBus)
      const loader = ref(false)
      const items = ref()
      const items_store = ref()
      const originalDetails = ref()
      const list = ref({
        agents: [],
        'selected.agents': null,
        representatives: [],
        'selected.representatives': null,
        clients: [],
        'selected.clients': null,
        agente_firmatario: [],
        'selected.agente_firmatario': null,
        rappresentantiFromAgente: [],
      });
      const detailInvoices = ref({})
      const hasDetails = ref(false)
      const detailsDialog = ref(false)
      const isOrderDetails = ref(false)
      const selectedYear = ref([])
      const oldSelectedYear = ref([])
      const searchString = ref('')
      const removePaid = ref(false)
      const removeDilazioni = ref(false)
      const removeCessati = ref(false)
      const removeSospensione = ref(false)
      const removePreavvisi = ref(false)
      const removeVolturati = ref(false)
      const detailFilterVersion = ref(0)
      const validationErrors = ref({})
      const submitted = ref(false)
      const selectedMonthYear = ref(null)
      const hasSearchedRepresentatives = ref(false)
      const loadingRepresentatives = ref(false)
      const rappresentanteFlag = ref(false)
      const isGroupedByRappresentante = ref(false)
      const useAgenteName = ref(false)
      const selectedRappresentanteFromAgente = ref(null)
      const loadingRappresentantiFromAgente = ref(false)

    
      onMounted(() => { 
        getAgenti()
        getAgentiFirmatario()
        getClienti()
      })

      const getAgenti = () => {
        loader.value = true
        utility.getAgenti(0)
        .then((res) => {
          list.value['agents'] = res.items
          // list.value['agents'].unshift({
          //   id: 0,
          //   name: 'TUTTI',
          //   email: null
          // })
          list.value['agents'] = list.value['agents'].map(agent => {
            return {...agent, disabled: false}
          })
        }).finally(() => {
          loader.value = false
        })
      }

      const getAgentiFirmatario = () => {
        utility.getAgenti(0)
        .then((res) => {
          list.value['agente_firmatario'] = res.items || []
        })
      }

      // const getRappresentanti = () => {
      // }

      const onRepresentativeFilter = (event) => {
        const filterValue = event && (event.filter || event.value || '').toString().trim();

        if (!filterValue || filterValue.length < 2) {
          hasSearchedRepresentatives.value = false;
          list.value['representatives'] = [];
          loadingRepresentatives.value = false;
          return;
        }

        loadingRepresentatives.value = true;
        utility.getListaRappresentantiAutoComplete(filterValue)
          .then((res) => {
            list.value['representatives'] = res.items || [];
            hasSearchedRepresentatives.value = true;
          })
          .finally(() => {
            loadingRepresentatives.value = false;
          });
      }

      const getClienti = () => {
        loader.value = true
        utility.getListaClienti()
        .then((res) => {
          list.value['clients'] = res.items
        }).finally(() => {
          loader.value = false
        })
      }

      const onSelectedChange = (type) => {
        if (useAgenteName.value && type === 'agents') {
          return
        }
        const selectedKeys = Object.keys(list.value).filter(key => 
          key.startsWith('selected') && key !== `selected.${type}`
        );
        selectedKeys.forEach(k => {
          list.value[k] = null
        });
      }

      const getAllowedAgentLabels = (resItems, searchParams) => {
        if (!resItems || typeof resItems !== 'object') {
          return []
        }

        const allKeys = Object.keys(resItems)

        if (searchParams && Array.isArray(searchParams.agents) && searchParams.agents.length) {
          const selectedIds = searchParams.agents
          const agentsList = list.value.agents || []
          const allowedNames = agentsList
            .filter(a => selectedIds.includes(a.id))
            .map(a => a.name)

          const intersected = allKeys.filter(k => allowedNames.includes(k))

          return intersected.length ? intersected : allKeys
        }

        return allKeys
      }

      const processSearchResults = (res, rappresentante, searchParams) => {
        if (rappresentante === 1 && res.items && res.items.RAPPRESENTANTI) {
          res.items.RAPPRESENTANTI.forEach(el => {
            el.label_mese = el.label
          })
          isGroupedByRappresentante.value = true
          items.value = res.items
          items_store.value = res.items
          return
        }

        let mesi = []
        const agenti = getAllowedAgentLabels(res.items, searchParams)

        agenti.forEach(agente => {
          if (!res.items[agente]) return
          Object.keys(res.items[agente]).forEach(el => {
            const row = res.items[agente][el]
            if (!row) return
            mesi.push(row.mese_emissione)
            row.label_mese = moment(row.mese_emissione).locale('it').format("MMMM YYYY").toUpperCase()
          })
        })

        mesi = [...new Set(mesi)]      
        mesi.forEach((mese, indice) => {
          mesi_filter.value.push({'id': indice, 'name': moment(mese).locale('it').format("MMMM YYYY").toUpperCase()})
        })
              
        const selectedCount = Object.values(searchParams)[0]?.length || 0
        if (selectedCount > 1) {
          res.items["TOTALE AGENZIE"] = [] 
          mesi.forEach(mese => {
            let total_month = {
              mese_emissione: '',
              npdp_energy:0,
              npdp_gas:0,
              totale_fatturato_energy:0,
              totale_fatturato_gas:0,
              totale_insoluto_active_energy:0,
              totale_insoluto_active_gas:0,
              totale_insoluto_dilazioni_energy:0,
              totale_insoluto_dilazioni_gas:0,
              totale_insoluto_energy:0,
              totale_insoluto_gas:0,
              totale_insoluto_in_riattivazione_energy:0,
              totale_insoluto_in_riattivazione_gas:0,
              totale_insoluto_in_sospensione_energy:0,
              totale_insoluto_in_sospensione_gas:0,
              totale_insoluto_inactive_energy:0,
              totale_insoluto_inactive_gas:0,
              totale_insoluto_rid_energy:0,
              totale_insoluto_rid_gas:0,
              totale_pagato_energy:0,
              totale_pagato_gas:0,
              totale_qta_energy:0,
              totale_qta_gas:0,
              totale_rid_fatturato_energy:0,
              totale_rid_fatturato_gas:0,
              totale_rid_insoluto_energy:0,
              totale_rid_insoluto_gas:0,
              totale_rid_pagato_energy:0,
              totale_rid_pagato_gas:0,
              details_energy: {},
              details_gas: {}
            }
            agenti.forEach(agente => {
              total_month.details_energy[agente] = []
              total_month.details_gas[agente] = []
            })
            agenti
            .filter(agente => agente !== 'TOTALE AGENZIE')
            .forEach(agente => {
              if (!res.items[agente]) return
              Object.keys(res.items[agente]).forEach(el => {
                const row = res.items[agente][el]
                if (!row) return
                if (row.mese_emissione == mese) {
                  Object.keys(total_month).forEach(key => {
                    if (typeof total_month[key] !== 'object') {
                      const value = Number(row[key] ?? 0)
                      total_month[key] += isNaN(value) ? 0 : value
                    } else {
                      total_month[key][agente].push(row[key])
                    }
                  }) 
                }
                total_month.mese_emissione = mese
                total_month.label_mese = moment(mese).locale('it').format("MMMM YYYY").toUpperCase()                  
              })
            })
            res.items["TOTALE AGENZIE"].push(total_month)
          })  
        }
        items.value = res.items
        items_store.value = res.items
      }

      const searchData = () => {
        if (useAgenteName.value && selectedRappresentanteFromAgente.value) {
          const searchParams = {representatives: [selectedRappresentanteFromAgente.value]}
          let array_years = null
          let monthYear = null
          const rappresentante = rappresentanteFlag.value ? 1 : 0

          if (selectedMonthYear.value) {
            monthYear = moment(selectedMonthYear.value).format("MM/YYYY")
          } else if (selectedYear.value && selectedYear.value.length) {
            array_years = (selectedYear.value.map(date => moment(date).year())).sort()
          } else {
            toast.add({severity:'warn', summary: 'Attenzione', detail:'Seleziona almeno un anno o un mese/anno'});
            return
          }
          selectedMonths.value = null
          mesi_filter.value = []
          isGroupedByRappresentante.value = false
          loader.value = true
          submitted.value = true
          
          service.getSummaryInsoluti(searchParams, array_years, hasDetails.value, monthYear, rappresentante)
            .then((res) => {
              processSearchResults(res, rappresentante, searchParams)
            })
            .finally(() => {
              resetDetailFilters()
              loader.value = false
            })
          return
        }

        const selectedNotEmptyKeys = Object.keys(list.value).filter(key => {
          if (key.startsWith('selected')) {
            //const originalKey = key.split('.')[1]; // Get the original key (e.g., 'agents' from 'selected.agents')
            const originalArray = list.value[key];
            if (originalArray != null) {
              return key
            }
          }
        });


        if (selectedNotEmptyKeys.length > 0) {
          submitted.value = true;
          loader.value = true
          let k = selectedNotEmptyKeys[0].split('.')[1]
          let array_years = null
          let monthYear = null
          const rappresentante = rappresentanteFlag.value ? 1 : 0

          if (selectedMonthYear.value) {
            monthYear = moment(selectedMonthYear.value).format("MM/YYYY")
          } else if (selectedYear.value && selectedYear.value.length) {
            array_years = (selectedYear.value.map(date => moment(date).year())).sort()
          } else {
            loader.value = false
            toast.add({severity:'warn', summary: 'Attenzione', detail:'Seleziona almeno un anno o un mese/anno'});
            return
          }
          selectedMonths.value = null
          mesi_filter.value = []
          isGroupedByRappresentante.value = false
          const searchParams = {[k]:list.value[selectedNotEmptyKeys[0]]}
          service.getSummaryInsoluti(searchParams, array_years, hasDetails.value, monthYear, rappresentante)
          .then((res) => {
            processSearchResults(res, rappresentante, searchParams)
          }).finally(() => {
            resetDetailFilters()
            loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento'});
        }
      }

      const onUseAgenteNameChange = () => {
        if (!useAgenteName.value) {
          selectedRappresentanteFromAgente.value = null
          list.value['rappresentantiFromAgente'] = []
        } else {
          if (list.value['selected.agents'] && list.value['selected.agents'].length === 1) {
            loadRappresentantiFromAgente(list.value['selected.agents'][0])
          }
        }
      }

      const loadRappresentantiFromAgente = (idAgente) => {
        if (!idAgente) return
        
        loadingRappresentantiFromAgente.value = true
        list.value['rappresentantiFromAgente'] = []
        selectedRappresentanteFromAgente.value = null
        
        utility.getListaRappresentantiFromAgenti(idAgente)
          .then((res) => {
            list.value['rappresentantiFromAgente'] = (res.items || []).map(rapp => {
              if (typeof rapp === 'object' && rapp !== null) {
                return {
                  id: rapp.id || rapp.cod_rapp || rapp.rappresentante_id,
                  name: rapp.name || rapp.ragione_sociale || rapp.denominazione || `${rapp.nome || ''} ${rapp.cognome || ''}`.trim() || 'Rappresentante'
                }
              }
              return rapp
            })
          })
          .catch((err) => {
            console.error('Errore nel caricamento rappresentanti:', err)
            toast.add({severity:'error', summary: 'Errore', detail:'Errore nel caricamento dei rappresentanti'})
          })
          .finally(() => {
            loadingRappresentantiFromAgente.value = false
          })
      }

    

      const changeSelection = (evt, type_selection) => {
        if (type_selection == 'year') {
          if (evt && evt.length > 0) {
            evt = evt.sort((a, b) => a - b)
            oldSelectedYear.value = selectedYear.value
          }
        } else if(type_selection == 'agents'){
          if (evt.length == 0) {
            list.value['agents'].forEach(agent => {
              agent.disabled = false
            })
            useAgenteName.value = false
            selectedRappresentanteFromAgente.value = null
            list.value['rappresentantiFromAgente'] = []
          } else if (evt.includes(0)) {
            list.value['agents'].forEach(agent => {
              agent.disabled = agent.id == 0 ? false : true
            })
            useAgenteName.value = false
            selectedRappresentanteFromAgente.value = null
            list.value['rappresentantiFromAgente'] = []
          } else {
            list.value['agents'].forEach(agent => {
              agent.disabled = false
            })
            if (evt.length === 1 && useAgenteName.value) {
              loadRappresentantiFromAgente(evt[0])
            } else if (evt.length !== 1) {
              useAgenteName.value = false
              selectedRappresentanteFromAgente.value = null
              list.value['rappresentantiFromAgente'] = []
            }
          }          
        }
      }

      const onGlobalSearch = () => {
        if (searchString.value.length > 0) {
          const filtered = cloneDetailInvoices(originalDetails.value)
          Object.keys(filtered).forEach(agent => {
            for (const keyName of Object.keys(filtered[agent])) {
              if (!keyName.includes(searchString.value.toUpperCase())) {
                delete filtered[agent][keyName]
              }
            }
          })
          detailInvoices.value = filterInvoiceGroups(filtered)
        } else {
          applyDetailFiltersSync()
        }
      }

      const onOrderDetails  = () => {
          isOrderDetails.value = !isOrderDetails.value
          let temp = {};
          if (isOrderDetails.value) {

            let arr = [];
            for (const [k, els] of Object.entries(detailInvoices.value)) {
              arr.push({
                'name': k,
                'tot_saldo': els.reduce((acc, el) => acc + el.saldo, 0),
              })
            }

            arr.sort((a, b) => b.tot_saldo - a.tot_saldo);

            arr.forEach(el => {
              temp[el.name] = detailInvoices.value[el.name]; 
            });
            
          } else {
            let key = Object.keys(detailInvoices.value).sort(); 

            key.forEach(k => {
              temp[k] = detailInvoices.value[k]; 
            });

          }
          
        detailInvoices.value = temp
      };

      const getSelectedMonthLabels = () => {
        if (selectedMonths.value && selectedMonths.value.length) {
          return selectedMonths.value.map(m => m.name)
        }

        if (selectedMonthYear.value) {
          return [
            moment(selectedMonthYear.value)
              .locale('it')
              .format("MMMM YYYY")
              .toUpperCase()
          ]
        }

        return null
      }

      const calculateTotal = (array, field, field2 = null, format = true) => {
        let total = 0
        const monthLabels = getSelectedMonthLabels()

        array.forEach(el => {
          
          if (monthLabels) {
            if (!el.label_mese || !monthLabels.includes(el.label_mese)) {
              return
            }
          }
          const v1 = Number(el[field] ?? 0)
          const v2 = field2 ? Number(el[field2] ?? 0) : 0
          total += v1 + v2
        })

        return format ? formatCurrency(total) : total;
      };

      const calculateTotalPercent = (array, typo, typo2 = null) => {
        let totalFatt = 0;
        let totalIns = 0;
        const monthLabels = getSelectedMonthLabels()

        array.forEach(el => {
          if (monthLabels) {
            if (!el.label_mese || !monthLabels.includes(el.label_mese)) {
              return
            }
          }
          const v1 = Number(el[`totale_fatturato_${typo}`] ?? 0)
          const v2 = typo2 ? Number(el[`totale_fatturato_${typo2}`] ?? 0) : 0
          totalFatt += v1 + v2
        })
        array.forEach(el => {
          if (monthLabels) {
            if (!el.label_mese || !monthLabels.includes(el.label_mese)) {
              return
            }
          }
          const v1 = Number(el[`totale_insoluto_${typo}`] ?? 0)
          const v2 = typo2 ? Number(el[`totale_insoluto_${typo2}`] ?? 0) : 0
          totalIns += v1 + v2
        })

        let percent = ((totalIns / totalFatt) * 100).toFixed(2)
        
        if (!isFinite(Number(percent))) {
          percent = Number(0).toFixed(2)
        }
        return percent + "%";
      }

      const showDetailsInvoices = async (label, index, typo, all) => {
        resetDetailFilters()
        searchString.value = ''
        detailInvoices.value = {}
        if (all) {
          Object.keys(items.value[label][index][`details_${typo}`]).forEach(agent => {
            if (agent != 'TOTALE AGENZIE') {
              detailInvoices.value[agent] = items.value[label][index][`details_${typo}`][agent][0]
            }
          })
        } else {
          detailInvoices.value[label] = items.value[label][index][`details_${typo}`]
        }

        originalDetails.value = cloneDetailInvoices(detailInvoices.value)
        applyDetailFiltersSync()
        detailsDialog.value = true
      }

      const viewTotalRapps = (label) => {
        resetDetailFilters()
        searchString.value = ''
        let arr = {}
        if (label in items.value) {
          items.value[label].forEach(elements => {
            ['energy', 'gas'].forEach(type => {
              for (const [rappName, els] of Object.entries(elements[`details_${type}`])) {
                if (!arr[rappName]) {
                  arr[rappName] = []
                }
                els.forEach(el => {
                  arr[rappName].push(el)
                })
              }
            })
          });
        }
        detailInvoices.value = { [label]: arr }
        originalDetails.value = cloneDetailInvoices(detailInvoices.value)
        applyDetailFiltersSync()
        detailsDialog.value = true
      }
      const resetDetailFilters = () => {
        removePaid.value = false
        removeDilazioni.value = false
        removeCessati.value = false
        removeSospensione.value = false
        removePreavvisi.value = false
        removeVolturati.value = false
      }

      const CESSATO_STATE = 3
      const SOSPENSIONE_STATES = [16, 18, 21, 22]
      const CESSATO_STATI = ['cessata', 'cessato']
      const SOSPENSIONE_STATI = [
        'in sospensione',
        'sospeso',
        'sospensione richiesta',
        'sospensione in lavorazione',
      ]
      const PREAVVISO_GIORNI_ENERGY = 27
      const PREAVVISO_GIORNI_GAS = 41

      const normalizeStato = (fattura) => {
        return (fattura?.stato_interno ?? '').toString().trim().toLowerCase()
      }

      const getCodTypeState = (fattura) => {
        const value = fattura?.cod_type_state
        return value === undefined || value === null ? null : Number(value)
      }

      const isGasInvoice = (fattura) => {
        if (fattura?.pod) return false
        if (fattura?.pdr) return true
        return false
      }

      const hasOpenDilazione = (fattura) => {
        if (fattura?.dilazione_aperta !== undefined) {
          const v = fattura.dilazione_aperta
          return v === true || v === 1 || v === '1'
        }
        if (fattura?.dilazione_stato !== undefined) {
          return Number(fattura.dilazione_stato) === 0
        }
        const value = fattura?.has_dilazione
        return value === true || value === 1 || value === '1'
      }

      const isCessato = (fattura) => {
        const code = getCodTypeState(fattura)
        if (code !== null) return code === CESSATO_STATE
        return CESSATO_STATI.includes(normalizeStato(fattura))
      }

      const isInSospensione = (fattura) => {
        const code = getCodTypeState(fattura)
        if (code !== null) return SOSPENSIONE_STATES.includes(code)
        return SOSPENSIONE_STATI.includes(normalizeStato(fattura))
      }

      const hasPreavvisoNonScaduto = (fattura) => {
        const dataInvio = fattura?.preavviso_data_invio
        if (!dataInvio || !moment(dataInvio).isValid()) return false
        const giorni = isGasInvoice(fattura) ? PREAVVISO_GIORNI_GAS : PREAVVISO_GIORNI_ENERGY
        return moment().diff(moment(dataInvio), 'days') < giorni
      }

      const isVolturato = (fattura) => Number(fattura?.is_volturato) === 1

      const invoicePasses = (fattura) => {
        if (removePaid.value && !(Number(fattura?.saldo) > 0)) return false
        if (removeDilazioni.value && hasOpenDilazione(fattura)) return false
        if (removeCessati.value && isCessato(fattura)) return false
        if (removeSospensione.value && isInSospensione(fattura)) return false
        if (removePreavvisi.value && hasPreavvisoNonScaduto(fattura)) return false
        if (removeVolturati.value && isVolturato(fattura)) return false
        return true
      }

      const getRemovalReason = (fattura) => {
        if (removePaid.value && !(Number(fattura?.saldo) > 0)) return 'SALDATA (saldo <= 0)'
        if (removeDilazioni.value && hasOpenDilazione(fattura)) return 'DILAZIONE APERTA'
        if (removeCessati.value && isCessato(fattura)) return 'PDP CESSATO'
        if (removeSospensione.value && isInSospensione(fattura)) return 'IN SOSPENSIONE'
        if (removePreavvisi.value && hasPreavvisoNonScaduto(fattura)) return 'PREAVVISO NON SCADUTO'
        if (removeVolturati.value && isVolturato(fattura)) return 'POD/PDR VOLTURATO'
        return null
      }

      const cloneDetailInvoices = (data) => {
        if (!data || typeof data !== 'object') return {}
        return JSON.parse(JSON.stringify(data))
      }

      const isAnyDetailFilterActive = () => {
        return removePaid.value
          || removeDilazioni.value
          || removeCessati.value
          || removeSospensione.value
          || removePreavvisi.value
          || removeVolturati.value
      }

      const filterInvoiceGroups = (data) => {
        if (!data || typeof data !== 'object') return {}
        if (!isAnyDetailFilterActive()) return cloneDetailInvoices(data)

        const result = {}
        Object.keys(data).forEach(agente => {
          const agentData = data[agente]
          if (!agentData || typeof agentData !== 'object') return

          const filteredGroups = {}
          Object.keys(agentData).forEach(rapp => {
            const invoices = agentData[rapp]
            if (!Array.isArray(invoices)) return

            const filtered = invoices.filter(invoicePasses)
            if (filtered.length > 0) {
              filteredGroups[rapp] = filtered
            }
          })

          if (Object.keys(filteredGroups).length > 0) {
            result[agente] = filteredGroups
          }
        })
        return result
      }

      const logRemovedInvoices = () => {
        if (!isAnyDetailFilterActive()) {
          console.log('[INSOLUTI] Nessun filtro attivo: nessuna fattura rimossa')
          return
        }
        const removed = []
        Object.keys(originalDetails.value).forEach(agente => {
          const agentData = originalDetails.value[agente]
          if (!agentData || typeof agentData !== 'object') return
          Object.keys(agentData).forEach(rapp => {
            const invoices = agentData[rapp]
            if (!Array.isArray(invoices)) return
            invoices.forEach(fattura => {
              const reason = getRemovalReason(fattura)
              if (reason) {
                removed.push({
                  numero: fattura.numero,
                  pdp: fattura.pod ?? fattura.pdr ?? null,
                  cliente: fattura.ragsoc,
                  rappresentante: rapp,
                  saldo: fattura.saldo,
                  cod_type_state: fattura.cod_type_state,
                  dilazione_aperta: fattura.dilazione_aperta,
                  preavviso_data_invio: fattura.preavviso_data_invio,
                  motivo: reason,
                })
              }
            })
          })
        })
        console.log(`[INSOLUTI] Filtri attivi:`, {
          removePaid: removePaid.value,
          removeDilazioni: removeDilazioni.value,
          removeCessati: removeCessati.value,
          removeSospensione: removeSospensione.value,
          removePreavvisi: removePreavvisi.value,
          removeVolturati: removeVolturati.value,
        })
        console.log(`[INSOLUTI] Fatture RIMOSSE: ${removed.length}`)
        console.table(removed)
      }

      const applyDetailFiltersSync = () => {
        if (!originalDetails.value || Object.keys(originalDetails.value).length === 0) return
        logRemovedInvoices()
        detailInvoices.value = filterInvoiceGroups(originalDetails.value)
        detailFilterVersion.value++
      }

      const applyDetailFilters = () => {
        nextTick(() => {
          applyDetailFiltersSync()
        })
      }

      watch(
        [removePaid, removeDilazioni, removeCessati, removeSospensione, removePreavvisi, removeVolturati],
        () => {
          if (!detailsDialog.value) return
          applyDetailFiltersSync()
        }
      )

      const exportPdf = (keyName = null) => {
        if (Object.keys(detailInvoices.value).length > 0) {
          loader.value = true
          service.exportPdfInsoluti(
            // keyName ? {[keyName]:detailInvoices.value[keyName]} : detailInvoices.value,
            keyName ? {[keyName]:originalDetails.value[keyName]} : originalDetails.value,
            removePaid.value
          ).finally(() => {
            loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun elemento da esportare'});
        }
        
      }

      const exportGlobalCsv = () => {
        if (Object.keys(detailInvoices.value).length > 0) {
          loader.value = true
          service.exportCsvInsoluti(
            // detailInvoices.value,
            originalDetails.value,
            removePaid.value
          ).finally(() => {
            loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun elemento da esportare'});
        }
      }

      const formatCurrency = (value) => {
        const num = Number(value)
        if (!isFinite(num)) {
          return (0).toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
        }
        return num.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      const previewSentInvoices = ref(new Set())
      const previewSendingInvoices = ref(new Set())

      const getFornituraId = (fattura) => {
        if (fattura?.pod) {
          return fattura.pod_id ?? fattura.cod_pod ?? null
        }
        if (fattura?.pdr) {
          return fattura.pdr_id ?? fattura.cod_pdr ?? null
        }
        return null
      }

      const sendToPreview = async (fattura) => {
        const isPod = !!fattura?.pod
        const typeFornitura = isPod ? 'pods' : 'pdrs'
        const fornituraId = getFornituraId(fattura)

        if (!fornituraId) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'ID fornitura non disponibile per questa fattura'});
          return
        }

        previewSendingInvoices.value.add(fattura.numero)
        loader.value = true
        try {
          await serviceOperation.createMultiPreSuspensionOrReactivation(
            [{ id: fornituraId }],
            typeFornitura,
            'sospensioni'
          )
          previewSentInvoices.value.add(fattura.numero)
        } finally {
          previewSendingInvoices.value.delete(fattura.numero)
          loader.value = false
        }
      }

      const exportCSV = (keyName) => {
        self.refs[`dt_insoluti_${keyName}`].exportCSV()
      };
      
      const exportPdfTable = () => {
        if (!items.value || Object.keys(items.value).length === 0) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun dato da esportare'});
          return
        }
        loader.value = true
        service.exportPdfSummaryTable(items.value)
          .finally(() => {
            loader.value = false
          })
      }

      const sendMailReport = () => {
        const selectedNotEmptyKeys = Object.keys(list.value).filter(key => {
          if (key.startsWith('selected')) {
            //const originalKey = key.split('.')[1]; // Get the original key (e.g., 'agents' from 'selected.agents')
            const originalArray = list.value[key];
            if (originalArray != null) {
              return key
            }
          }
        });


        if (selectedNotEmptyKeys.length > 0) {
          submitted.value = true;
          loader.value = true
          let k = selectedNotEmptyKeys[0].split('.')[1]
          let years = null
          let monthYear = null
          const rappresentante = rappresentanteFlag.value ? 1 : 0

          if (selectedMonthYear.value) {
            monthYear = moment(selectedMonthYear.value).format("MM/YYYY")
          } else if (selectedYear.value && selectedYear.value.length) {
            years = selectedYear.value.map(date => moment(date).year())
          } else {
            loader.value = false
            toast.add({severity:'warn', summary: 'Attenzione', detail:'Seleziona almeno un anno o un mese/anno'});
            return
          }

          service.sendPdfSummaryInsoluti(
            {[k]:list.value[selectedNotEmptyKeys[0]]},
            years,
            hasDetails.value,
            monthYear,
            rappresentante
          )
          .then((res)=>{
            let severity = res.items.success ? 'success' : 'danger'
            let summary = res.items.success ? 'Successo' : 'Attenzione'
            let detail = res.items.message 
            
            toast.add({severity:severity, summary: summary, detail:detail,life: 10000});
          })
          .finally(() => {
            loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento'});
        }
      }

      const setItems = () => {
        if (selectedMonths.value.length) {
          selectedMonths.value = selectedMonths.value.sort((a, b) => a.id - b.id)
          items.value = {}
          Object.keys(items_store.value).forEach(agente =>{
            items.value[agente] = []
            items_store.value[agente].forEach(item => {
              selectedMonths.value.forEach(mese => {
                if (item.label_mese == mese.name) {
                  items.value[agente].push(item)
                }
              })
            })
          })
        }else{
          items.value = items_store.value
        }
      }

      const hideDialog = () => {
        detailsDialog.value = false
        detailInvoices.value = {}
        originalDetails.value = null
        searchString.value = ''
        resetDetailFilters()
      }

      return {
        // dt,
        list,
        exportCSV,
        moment,
        items,
        loader, 
        filters, 
        detailInvoices,
        hasDetails,
        detailsDialog,
        searchData,
        onSelectedChange,
        selectedYear,
        calculateTotal,
        calculateTotalPercent,
        showDetailsInvoices,
        searchString,
        isOrderDetails,
        onOrderDetails,
        onGlobalSearch,
        viewTotalRapps,
        removePaid,
        removeDilazioni,
        removeCessati,
        removeSospensione,
        removePreavvisi,
        removeVolturati,
        detailFilterVersion,
        applyDetailFilters,
        sendToPreview,
        previewSentInvoices,
        previewSendingInvoices,
        exportPdf,
        exportGlobalCsv,
        formatCurrency,
        validationErrors,
        submitted,
        sendMailReport,
        exportPdfTable,
        changeSelection,
        mesi_filter,
        setItems,
        selectedMonths,
        items_store,
        hideDialog,
        selectedMonthYear,
        onRepresentativeFilter,
        hasSearchedRepresentatives,
        loadingRepresentatives,
        rappresentanteFlag,
        isGroupedByRappresentante,
        useAgenteName,
        selectedRappresentanteFromAgente,
        loadingRappresentantiFromAgente,
        onUseAgenteNameChange,
      }
  }
}
</script>

<style scoped>
.p-error {
  color: #f33d3d;
}
.preview-btn {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.preview-btn:hover {
  background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.45);
}
.preview-btn:active {
  transform: translateY(0);
}
.insoluti-summary .border {
  border-radius: 18px;
  padding: 20px;
  border: 1px solid #3333331f;
}
.green-dot {
    background-color: rgb(71, 236, 71);
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .red-dot {
    background-color: rgb(255, 81, 81);
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
</style>
<style>
.insoluti-summary .p-datatable .p-datatable-thead > tr > th.th-power {
  background: rgba(251, 230, 138, 0.742) !important;
  min-width: 120px;
}

.insoluti-summary .p-datatable .p-datatable-thead > tr > th.th-gas {
  background: rgba(137, 185, 244, 0.412) !important;  
  min-width: 120px;
}

.insoluti-summary .p-datatable .p-datatable-tbody > tr > td.border-lt, .p-datatable .p-datatable-thead > tr > th.border-lt {
  border-left: 1px solid rgba(62, 62, 62, 0.093);
}
.insoluti-summary .p-datatable .p-datatable-tfoot > tr > td.td-footer {
 color: #0a8cf5 !important;
 font-size: 15px;
}
.insoluti-summary .p-datatable .p-datatable-tbody > tr > td.sticky-cell {
  position: sticky !important;
  left: 0 !important;
  background-color: rgb(249, 249, 249);
  z-index: 10;
}
.insoluti-dialog .p-accordion-header-link {
  padding: 7px !important;
}
.p-small{
  color:rgb(127, 134, 141);
}
.flex {
    display: flex !important;
}
.justify-content-end {
    justify-content: flex-end !important;
}
.align-items-end {
    align-items: flex-end !important;
}
</style>
